import EventEmitter from 'wolfy87-eventemitter/EventEmitter.min'

CHANGE_EVENT = 'change'

###*
@class BaseStore
@extends EventEmitter
@param dispatcher The dispatcher interface
@constructor
###
class BaseStore extends EventEmitter
  constructor: (@dispatcher) ->
    @initialize() if @initialize

  ###*
  Add a listener for the change event
  @method addChangeListener
  @param {Function} callback
  ###
  addChangeListener: (callback) ->
    @on CHANGE_EVENT, callback
    return


  ###*
  Remove a listener for the change event
  @method removeChangeListener
  @param {Function} callback
  ###
  removeChangeListener: (callback) ->
    @removeListener CHANGE_EVENT, callback

  ###*
  Emit a change event
  @method emitChange
  ###
  emitChange: ->
    @emit CHANGE_EVENT

window.FluxBaseStore = BaseStore
